<template>
  <div>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card flat>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-file-cabinet</v-icon>
          RESERVAR GUIAS POR CLIENTE
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrarDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="4" md="4">
              <v-autocomplete
                v-model="cliente_seleccionado"
                :items="datos.clientes"
                item-text="CLI_NOMBRE"
                item-value="ENTE_ID"
                label="Seleccionar Cliente"
                outlined
                dense
                return-object
                :rules="[v => !!v || 'El cliente es requerido']"
              >
                <template v-slot:item="data">
                  
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.CLI_NOMBRE }}</v-list-item-title>                      
                    </v-list-item-content>
                  
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="agente_seleccionado"
                :items="datos.agentes"
                item-text="AGT_NOMBRE"
                item-value="AGT_ID"
                label="Agente"
                outlined
                dense
                return-object
                :rules="[v => !!v || 'El agente es requerido']"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="shipper_seleccionado"
                :items="datos.shippers"
                item-text="SHP_NOMBRE"
                item-value="SHP_ID"
                label="Shipper"
                outlined
                dense
                return-object
                :rules="[v => !!v || 'El shipper es requerido']"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-2">Lista de Reservas</div>
              <v-data-table
                :headers="headersLista"
                :items="lista_reservas"
                item-key="key"
                class="elevation-1"
                dense
                hide-default-footer
              >
                <template v-slot:item.fecha="{ item }">
                  <v-text-field
                    v-model="item.fecha"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="py-1"
                  ></v-text-field>
                </template>

                <template v-slot:item.aerolinea_id="{ item }">
                  <v-select
                    v-model="item.aerolinea_id"
                    :items="datos.aerolineas"
                    item-text="AEROLINEA_NOMBRE"
                    item-value="AEROLINEA_ID"
                    dense
                    outlined
                    hide-details
                    class="py-1"
                  ></v-select>
                </template>

                <template v-slot:item.pais_id="{ item }">
                  <v-autocomplete
                    v-model="item.pais_id"
                    :items="datos.ciudades"
                    item-text="CIUPA_DESC"
                    item-value="CIUPA_ID"
                    dense
                    outlined
                    hide-details
                    class="py-1"
                    :rules="[v => !!v || 'El país es requerido']"
                    @change="item.destino_id = null"
                  ></v-autocomplete>
                </template>

                <template v-slot:item.destino_id="{ item }">
                  <v-select
                    v-model="item.destino_id"
                    :items="getAeropuertosPorPais(item.pais_id)"
                    item-text="AP_NOMBRE"
                    item-value="AEROPUERTO_ID"
                    dense
                    outlined
                    hide-details
                    class="py-1"
                    :disabled="!item.pais_id"
                    :rules="[v => !!v || 'El aeropuerto es requerido']"
                  ></v-select>
                </template>

                <template v-slot:item.cantidad="{ item }">
                  <div class="d-flex align-center">
                    <v-btn icon small @click="item.cantidad = Math.max(1, item.cantidad - 1)">
                      <v-icon small>mdi-minus</v-icon>
                    </v-btn>
                    <v-text-field
                      v-model.number="item.cantidad"
                      type="number"
                      min="1"
                      dense
                      outlined
                      hide-details
                      class="mx-1 text-center"
                      style="width: 60px"
                    ></v-text-field>
                    <v-btn icon small @click="item.cantidad++">
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn icon small color="error" @click="eliminarReserva(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>

                <template v-slot:body.append>
                  <tr>
                    <td colspan="6">
                      <v-btn small text color="primary" @click="agregarReserva">
                        <v-icon left small>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12" class="text-center">
              <v-btn
                color="success"
                large
                :loading="loadingBtn"
                :disabled="!puedeProcesar"
                @click="procesarReservas"
              >
                <v-icon left>mdi-check</v-icon>
                PROCESAR RESERVAS
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="my-4" v-if="guias_resultado.length > 0"></v-divider>

          <v-row v-if="guias_resultado.length > 0">
            <v-col cols="12">
              <div class="text-subtitle-1 mb-2">Guias Ingresadas</div>
              <v-data-table
                :headers="headersResultado"
                :items="guias_resultado"
                item-key="AWB_NUM"
                class="elevation-1"
                dense
                hide-default-footer
              >
                <template v-slot:item.FECHA="{ item }">
                  {{ formatoFecha(item.FECHA) }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<style>
#listaInventario td,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 0.65rem !important;
}
</style>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "ReservaGuiasCliente",

  props: {
    dialog: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    overlay: false,
    loadingBtn: false,

    cliente_seleccionado: null,
    agente_seleccionado: null,
    shipper_seleccionado: null,
    lista_reservas: [],
    guias_resultado: [],

    datos: {
      clientes: [],
      aerolineas: [],
      aeropuertos: [],
      ciudades: [],
      shippers: [],
      agentes: []
    },

    headersLista: [
      { text: "Fecha", value: "fecha", width: "150px" },
      { text: "Aerolínea", value: "aerolinea_id", width: "150px" },
      { text: "País Destino", value: "pais_id", width: "180px" },
      { text: "Aeropuerto", value: "destino_id", width: "180px" },
      { text: "Cantidad", value: "cantidad", width: "100px", align: "center" },
      { text: "", value: "actions", width: "50px", sortable: false }
    ],

    headersResultado: [
      { text: "Número de Guía", value: "AWB_NUM", width: "150px" },
      { text: "Fecha Vuelo", value: "FECHA", width: "150px" },
      { text: "Destino", value: "DESTINO" }
    ],

    keyCounter: 0
  }),

  computed: {
    ...mapState("master", ["user"]),

    puedeProcesar() {
      if (!this.cliente_seleccionado) return false;
      if (!this.agente_seleccionado) return false;
      if (!this.shipper_seleccionado) return false;
      if (this.lista_reservas.length === 0) return false;
      return this.lista_reservas.every(r =>
        r.fecha && r.aerolinea_id && r.pais_id && r.destino_id && r.cantidad >= 1
      );
    }
  },

  created() {
    this.cargarDatos();
  },

  methods: {
    ...mapActions("master", ["requestApi", "alertNotification"]),    
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setTitleToolbar",
      "setLoadingTable",
    ]),
    async cargarDatos() {


      this.overlay = true;
      this.setUrl("api/datos-inventario-guias");
      this.requestApi({        
        method: "GET",
        data: {}
      })
        .then(response => {
          this.datos.clientes = response.data.clientes || [];
          this.datos.aerolineas = response.data.aerolineas || [];
          this.datos.aeropuertos = response.data.aeropuertos || [];
          this.datos.ciudades = response.data.ciudades || [];
          this.datos.shippers = response.data.shippers || [];
          this.datos.agentes = response.data.agentes || [];
          this.overlay = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudieron cargar los datos"
          });
        })
        .finally(() => {
          this.overlay = false;
        });
      
      
      
    },

    agregarReserva() {
      this.lista_reservas.push({
        key: this.keyCounter++,
        fecha: "",
        aerolinea_id: null,
        pais_id: null,
        destino_id: null,
        cantidad: 1
      });
    },

    eliminarReserva(item) {
      const index = this.lista_reservas.findIndex(r => r.key === item.key);
      if (index !== -1) {
        this.lista_reservas.splice(index, 1);
      }
    },

    async procesarReservas() {
      if (!this.cliente_seleccionado) {
        Swal.fire({
          icon: "warning",
          title: "Advertencia",
          text: "Seleccione un cliente"
        });
        return;
      }

      const listaFormateada = this.lista_reservas.map(r => ({
        fecha: r.fecha,
        aerolinea_id: r.aerolinea_id,
        destino_id: r.destino_id,
        cantidad: r.cantidad,
        ciudad_id: r.pais_id
      }));

      this.loadingBtn = true;
      this.overlay = true;      

      this.setUrl("api/reservar-guias-cliente");
      this.requestApi({        
        method: "POST",
        data: {
            cliente_id: this.cliente_seleccionado.ENTE_ID,
            agente_id: this.agente_seleccionado.AGT_ID,
            shipper_id: this.shipper_seleccionado.SHP_ID,
            user_name: this.user.USER_NAME,
            lista: listaFormateada
          }
      }).then(response => {
          let mensaje = response.data.msg || "Error al procesar reservas";
          if (response.data.errores && response.data.errores.length > 0) {
            mensaje += "\n" + response.data.errores.join("\n");
          }
          Swal.fire({
            icon: "warning",
            title: "Advertencia",
            text: mensaje
          });

          if (response.data.guias_reservadas && response.data.guias_reservadas.length > 0) {
            this.guias_resultado = response.data.guias_reservadas;
          }

      }).catch(error => {
        this.loadingBtn = false;
        this.overlay = false;
        
        
        let mensajes = error.response.data.errores || [];
        //let mensaje = error.response?.data?.msg || "Error al procesar reservas";
        let mensaje = "";
        if (mensajes.length > 0) {
           mensaje += "\n" + mensajes.join("\n");
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al procesar las reservas zz: " +  mensaje
        });
      }).finally(() => {
        this.loadingBtn = false;
        this.overlay = false;
      });
      

    },

    formatoFecha(fecha) {
      if (!fecha) return "";
      return fecha;
    },

    getAeropuertosPorPais(paisId) {
      if (!paisId) return [];
      return this.datos.aeropuertos.filter(a => a.CIUPA_ID === paisId);
    },

    cerrarDialog() {
      this.$emit("close");
    },

    limpiar() {
      this.cliente_seleccionado = null;
      this.agente_seleccionado = null;
      this.shipper_seleccionado = null;
      this.lista_reservas = [];
      this.guias_resultado = [];
      this.keyCounter = 0;
    }
  }
};
</script>

<style>
.theme--light.v-data-table tbody tr.v-data-table__selected {
  background: #6eaff8;
}
</style>